import React, { useEffect, useState } from 'react';
import Loader from '../components/Loader';
import { useNavigate, useParams } from 'react-router-dom';
import { getProductBySlug } from '../Api/products';
import ProductCard from '../components/ProductCard'; 
import { capitalize } from '@mui/material';
import '../assets/css/searchresult.css';


function SearchResult({ isAuthenticated, onAddToCart }) {

    const navigate = useNavigate()
    const { searchInput } = useParams();
    const [loading, setLoading] = useState(false);
    const [searchResult, setSearchResult] = useState([]);

    useEffect(() => {
        if (!searchInput) {
            console.log('No search input provided');
            setLoading(false);
            setSearchResult([]);
            return;
        }

        console.log('searchInput:', searchInput);

        async function fetchData() {
            setLoading(true);
            try {
                const response = await getProductBySlug(searchInput.trim());
                setSearchResult(response || []);
            } catch (error) {
                console.error('Fetch error:', error);
                setSearchResult([]);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [searchInput]);

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div className="content-wrapper">
                    <section className="search-result">
                        <div className="small-container">
                            <h3 style={{ textAlign: "center", padding: "5% 0 20px" }}>Search results for {capitalize(searchInput) || 'No Input'}</h3>
                            <section className="char-products-section">
                                <div className="small-container d-grid" style={{ margin: '0 0 0 54px' }}>
                                    {searchResult.length > 0 ? (
                                        searchResult.map(item => (
                                            <ProductCard
                                                isAuthenticated={isAuthenticated}
                                                onAddToCart={onAddToCart}
                                                key={item.id}
                                                product={item}
                                            />
                                        ))
                                    ) : (
                                        <p>No products found!</p>
                                    )}
                                </div>
                            </section>
                        </div>
                    </section>
                </div>
            )}
        </>
    );
}

export default SearchResult;